export const HERO_CARDS_SET_1 = [
  'https://images.pokemontcg.io/base1/4_hires.png',
  'https://images.pokemontcg.io/base1/2_hires.png',
  'https://images.pokemontcg.io/base1/15_hires.png',
  'https://images.pokemontcg.io/smp/SM199_hires.png',
  'https://images.pokemontcg.io/swsh3/20_hires.png',
  'https://images.pokemontcg.io/swsh4/44_hires.png',
];

export const HERO_CARDS_SET_2 = [
  'https://images.pokemontcg.io/swsh7/215_hires.png',
  'https://images.pokemontcg.io/swsh9/172_hires.png',
  'https://images.pokemontcg.io/swsh11/196_hires.png',
  'https://images.pokemontcg.io/swsh12/201_hires.png',
  'https://images.pokemontcg.io/sv1/248_hires.png',
  'https://images.pokemontcg.io/sv2/254_hires.png',
];

export const HERO_CARDS_SET_3 = [
  'https://images.pokemontcg.io/sv3/223_hires.png',
  'https://images.pokemontcg.io/sv3pt5/199_hires.png',
  'https://images.pokemontcg.io/sv4pt5/234_hires.png',
  'https://images.pokemontcg.io/base1/4_hires.png',
  'https://images.pokemontcg.io/smp/SM199_hires.png',
];
